import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ParagraphEntity,
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphPartnersOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphPartnersOverview: React.FC<ParagraphPartnersOverviewProps> = ({ entity }) => {
  const paragraph = entity.toJS();

  return (
    <div className="Paragraph ParagraphPartnersOverview">
      <Container>
        <View
          classes="row"
          id="partners"
          display="overview"
          withProvider
        />
      </Container>
    </div>
  );
};

export default ParagraphPartnersOverview;
